import DOMPurify from 'dompurify';

/**
 * Testo formattato: ripulitura e conversione.
 *
 * Il regolamento lo scrive un amministratore e lo legge tutto il condominio,
 * quindi non e' contenuto di cui fidarsi a occhi chiusi: fra chi lo scrive e
 * chi lo legge c'e' sempre una ripulitura, sia quando si salva sia quando si
 * mostra. Due volte, perche' in mezzo c'e' un database che puo' aver ricevuto
 * quel campo anche da un'altra strada.
 *
 * L'elenco dei tag ammessi e' corto di proposito: un regolamento sono titoli,
 * paragrafi, elenchi e qualche parola in grassetto. Tutto il resto — immagini,
 * tabelle, stili, iframe — non serve a nessuno e allarga solo il bersaglio.
 */

const TAG_AMMESSI = ['p', 'br', 'strong', 'b', 'em', 'i', 'u', 'h2', 'h3', 'ul', 'ol', 'li', 'blockquote', 'a'];
const ATTRIBUTI_AMMESSI = ['href', 'target', 'rel'];

/** Marcatori che tradiscono un testo gia' formattato. */
const HA_MARCATURA = new RegExp(`<(${TAG_AMMESSI.join('|')})\\b[^>]*>`, 'i');

/** HTML ridotto a cio' che un regolamento puo' contenere. */
export function pulisci(html) {
    return DOMPurify.sanitize(String(html == null ? '' : html), {
        ALLOWED_TAGS: TAG_AMMESSI,
        ALLOWED_ATTR: ATTRIBUTI_AMMESSI,
        // niente `javascript:` e simili: restano i protocolli di un documento
        ALLOWED_URI_REGEXP: /^(?:https?:|mailto:|tel:|#|\/)/i
    });
}

/** Il solo testo, senza marcatura. */
export function soloTesto(html) {
    const valore = String(html == null ? '' : html);
    if (!HA_MARCATURA.test(valore)) return valore;
    const doc = new DOMParser().parseFromString(pulisci(valore), 'text/html');
    return doc.body.textContent || '';
}

/**
 * Vuoto per chi legge. Un editor «vuoto» non e' una stringa vuota: resta
 * dentro il paragrafo con cui il browser tiene vivo il cursore.
 */
export function eVuoto(html) {
    return soloTesto(html).replace(/ /g, ' ').trim() === '';
}

/** Distingue un regolamento formattato da uno battuto a macchina. */
export function eFormattato(valore) {
    return HA_MARCATURA.test(String(valore == null ? '' : valore));
}

/**
 * Testo semplice portato a HTML, per aprire nell'editor i regolamenti scritti
 * prima che l'editor esistesse: la riga vuota separa i paragrafi, l'a capo
 * singolo resta un a capo. Senza questo passaggio si aprirebbero come un
 * unico blocco, perche' l'HTML gli a capo non li guarda.
 */
export function daTestoSemplice(testo) {
    const valore = String(testo == null ? '' : testo);
    if (valore.trim() === '') return '';
    const scudo = valore
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    return scudo
        .split(/\n{2,}/)
        .map(par => `<p>${par.replace(/\n/g, '<br>')}</p>`)
        .join('');
}

/** Valore pronto per l'editor, qualunque sia la strada da cui arriva. */
export function perEditor(valore) {
    return eFormattato(valore) ? pulisci(valore) : daTestoSemplice(valore);
}
